import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import MyCourses from "../views/MyCourses.vue";
import MyOnlineClasses from "../views/MyOnlineClasses.vue";
import SaveCourse from "../views/SaveCourse.vue";
import Ticket from "../views/Ticket.vue";
import TicketDetail from "../views/TicketDetail.vue";
import EditCourse from "../views/EditCourse.vue";
import Profile from "../views/Profile.vue";
import Finance from "../views/Finance.vue";
import MyArticles from "../views/MyArticles.vue";

import Login from "../views/Login.vue";
import NotFound from "../views/NotFound.vue";

import ls from "localstorage-slim";
import * as rls from "./roles";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
      Role: [0, 1, 2],
    },
  },
  {
    path: "/mycourses",
    name: "MyCourses",
    component: MyCourses,
    meta: {
      requiresAuth: true,
      Role: [0, 2],
    },
  },
  {
    path: "/my-online-classes",
    name: "MyOnlineClasses",
    component: MyOnlineClasses,
    meta: {
      requiresAuth: true,
      Role: [0, 1, 2],
    },
  },
  {
    path: "/myarticles",
    name: "MyArticles",
    component: MyArticles,
    meta: {
      requiresAuth: true,
      Role: [1, 2],
    },
  },
  {
    path: "/save-course",
    name: "SaveCourse",
    component: SaveCourse,
    meta: {
      requiresAuth: true,
      Role: [0, 2],
    },
  },
  {
    path: "/editCourse",
    name: "EditCourse",
    component: EditCourse,
    meta: {
      requiresAuth: true,
      Role: [0, 2],
    },
  },
  {
    path: "/finance",
    name: "Finance",
    component: Finance,
    meta: {
      requiresAuth: true,
      Role: [0, 1, 2],
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true,
      Role: [0, 1, 2],
    },
  },

  {
    path: "/ticket",
    name: "Ticket",
    component: Ticket,
    meta: {
      requiresAuth: true,
      Role: [0, 1, 2],
    },
  },
  {
    path: "/ticket-detail",
    name: "TicketDetail",
    component: TicketDetail,
    meta: {
      requiresAuth: true,
      Role: [0, 1, 2],
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  var usr = JSON.parse(ls.get("user"));
  if (!usr && to.meta.requiresAuth) {
    ls.clear();
    router.push("/login");
  }
  if (to.meta.requiresAuth) {
    if (!to.meta.Role.includes(usr.Type)) {
      ls.clear();
      router.push("/login");
    }
  }
  next();
});

export default router;
